import React from 'react';

const StrategyResultItemSkeleton = () => {
  return (
    <div className="self-stretch px-4 py-3 bg-white inline-flex justify-start items-center gap-2 border-b border-neutral-050 last:border-none">
      {/* Checkbox skeleton */}
      <div className="pt-0.5 flex items-center gap-2">
        <div className="w-4 h-4 bg-gradient-to-r from-neutral-200 via-neutral-100 to-neutral-200 rounded overflow-hidden relative">
          <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
        </div>
      </div>
      
      {/* Content skeleton */}
      <div className="flex-1 inline-flex flex-col justify-start items-start gap-2">
        {/* Header section */}
        <div className="self-stretch inline-flex justify-between items-start">
          <div className="inline-flex flex-col justify-start items-start gap-1.5">
            {/* Name */}
            <div className="h-4 w-32 bg-gradient-to-r from-neutral-200 via-neutral-100 to-neutral-200 rounded overflow-hidden relative">
              <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
            </div>
            {/* Specialty */}
            <div className="h-3 w-24 bg-gradient-to-r from-neutral-200 via-neutral-100 to-neutral-200 rounded overflow-hidden relative">
              <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
            </div>
            {/* City */}
            <div className="h-3 w-20 bg-gradient-to-r from-neutral-200 via-neutral-100 to-neutral-200 rounded overflow-hidden relative">
              <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
            </div>
          </div>
          {/* Status badges skeleton */}
          <div className="flex gap-1">
            <div className="w-16 h-6 bg-gradient-to-r from-neutral-200 via-neutral-100 to-neutral-200 rounded-full overflow-hidden relative">
              <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
            </div>
            <div className="w-20 h-6 bg-gradient-to-r from-neutral-200 via-neutral-100 to-neutral-200 rounded-full overflow-hidden relative">
              <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
            </div>
          </div>
        </div>
        
        {/* Bottom section */}
        <div className="self-stretch inline-flex justify-between items-center gap-2">
          {/* Lists skeleton */}
          <div className="flex gap-1">
            <div className="w-12 h-5 bg-gradient-to-r from-neutral-200 via-neutral-100 to-neutral-200 rounded overflow-hidden relative">
              <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
            </div>
            <div className="w-16 h-5 bg-gradient-to-r from-neutral-200 via-neutral-100 to-neutral-200 rounded overflow-hidden relative">
              <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
            </div>
          </div>
          {/* Date skeleton */}
          <div className="h-3 w-24 bg-gradient-to-r from-neutral-200 via-neutral-100 to-neutral-200 rounded overflow-hidden relative">
            <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default StrategyResultItemSkeleton;